import { useState } from 'react'
import { useCallback } from 'react'

import { BEs, indieBEs } from '../../main/hotelBrandsAndChains'

export function getBEs(brand) {
  switch (brand) {
    case 'ihg':
      return { ihg: 'ihg.com' }

    case 'choice':
      return { choicehotels: 'choicehotels.com' }

    case 'radisson':
      return { radissonhotels: 'radissonhotels.com' }

    case 'wyndham':
      return { wyndhamhotels: 'wyndhamhotels.com' }

    case 'marriott':
      return { marriott: 'marriott.com' }

    case 'hilton':
      return { hilton: 'hilton.com' }

    case 'hyatt':
      return { hyatt: 'hyatt.com' }

    case 'bestwestern':
      return { bestwestern: 'bestwestern.com' }

    case 'independent':
      return indieBEs

    case 'sonesta':
      return { sonesta: 'sonesta.com' }

    default:
      break
  }
}

export const useBEOptions = () => {
  const [BEOptions, setBEOptions] = useState({})
  const [brand, setBrand] = useState()

  const handleChangeBrand = useCallback(
    newBrand => {
      if (brand !== newBrand) {
        setBrand(newBrand)
        setBEOptions(getBEs(newBrand))
      }
    },
    [brand]
  )

  return [BEOptions, handleChangeBrand]
}
